// Firebase configuration — selected by REACT_APP_APPLI_ENV via the committed
// environment bundles in src/config/environments.js (dev vs prod).
import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import env from '../config/environments';

// Initialize Firebase
const app = initializeApp(env.firebase);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export default app;
